import React, { useCallback } from 'react'
import { FormikHelpers } from 'formik'
import { useHistory } from 'react-router-dom'
import { useCreateDamageReport } from 'api'
import { PromptModal } from 'components'
import {
  DamageReportForm,
  FormDamageReport,
  serializeDamageReport,
} from './DamageReportForm'
import { useTranslation } from 'react-i18next'

export const DamageReportPage = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const navigateToOverview = useCallback(() => history.push('/'), [history])
  const [mutate, { status, reset }] = useCreateDamageReport()
  const onSubmit = useCallback(
    (values: FormDamageReport, helpers: FormikHelpers<FormDamageReport>) => {
      const damageReport = serializeDamageReport(values)
      mutate({ damageReport })
      helpers.setSubmitting(false)
    },
    [mutate]
  )

  return (
    <>
      <h1 id="damage-overview-title-e2e">
        {t('pages.damageReports.damageReportForm.damageReportPage.heading')}
      </h1>
      <DamageReportForm onSubmit={onSubmit} />

      {status === 'success' && (
        <PromptModal
          headline={t(
            'pages.damageReports.damageReportForm.damageReportPage.success.heading'
          )}
          confirmCallback={navigateToOverview}
          confirmText={t(
            'pages.damageReports.damageReportForm.damageReportPage.success.confirm'
          )}
        >
          {t(
            'pages.damageReports.damageReportForm.damageReportPage.success.info'
          )}
        </PromptModal>
      )}

      {status === 'failure' && (
        <PromptModal
          headline={t(
            'pages.damageReports.damageReportForm.damageReportPage.failure.heading'
          )}
          confirmCallback={reset}
          confirmText={t(
            'pages.damageReports.damageReportForm.damageReportPage.failure.confirm'
          )}
        >
          {t(
            'pages.damageReports.damageReportForm.damageReportPage.failure.info'
          )}
        </PromptModal>
      )}
    </>
  )
}
